import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-successful',
  templateUrl: './payment-successful.component.html',
  styleUrls: ['./payment-successful.component.scss']
})
export class PaymentSuccessfulComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
